import {
  object,
  string,
  optional,
  record,
  any,
  type as struct_type,
  intersection,
} from 'superstruct';

/**
 * Settings that are applied to embeddedservice_bootstrap.settings
 * These control the behavior and appearance of the Salesforce Messaging for Web chat widget.
 *
 * We explicitly model known settings (like `language`) while still allowing
 * additional Salesforce-supported settings to pass through without validation.
 */
const salesforceSettingsSchema = intersection([
  struct_type({
    language: optional(string()),
    scrt2URL: optional(string()),
  }),
  record(string(), any()),
]);

const salesforcePrechatSchema = object({
  // Hidden pre-chat fields (not shown to the user).
  // Values should be primitives (for example: strings, numbers, or booleans)
  // to match the Salesforce `setHiddenPrechatFields` contract.
  hidden: optional(record(string(), any())),
});

export const salesforceLiveChatConfigSchema = object({
  // Required: Salesforce org ID (e.g., '00DXXXXXXXXXXXX')
  salesforceEmbeddedOrgId: string(),

  // Required: Deployment/site name (e.g., 'Production_Chat')
  salesforceEmbeddedDeploymentId: string(),

  // Required: Salesforce site URL where chat is deployed
  salesforceEmbeddedEndpointUrl: string(),

  // Optional: Settings applied to embeddedservice_bootstrap.settings
  settings: optional(salesforceSettingsSchema),

  // Optional: Options passed as 4th parameter to embeddedservice_bootstrap.init()
  // Used for infrastructure configuration (e.g., scrt2URL for secure domains)
  initOptions: optional(record(string(), any())),

  // Optional: Pre-chat configuration applied via Salesforce prechatAPI
  prechat: optional(salesforcePrechatSchema),

  // Optional: Chat type identifier sent as a hidden pre-chat field.
  // Set by integrating apps (e.g., 'B2B'). When omitted, chattype is
  // excluded from hidden pre-chat values sent to Salesforce.
  chatType: optional(string()),

  // Required: The API name of the Enhanced Chat Embedded Service deployment,
  // used for REST API calls (access-token, close-conversation).
  // Example: 'Enhanced_chat_custom_client_app'
  esDeveloperName: string(),
});
